"use strict";

exports.__esModule = true;
var _ComponentSize = require("./ComponentSize");
Object.keys(_ComponentSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ComponentSize[key]) return;
  exports[key] = _ComponentSize[key];
});